<!--

List of accepted formats
DateTime formats
12h (AM/PM)
YYYY-MM-DD h:i:s, DD-MM-YYYY h:i:s, MM-DD-YYYY h:i:s, YYYY-MM-DD h:i, DD-MM-YYYY h:i, MM-DD-YYYY h:i, YYYY/MM/DD h:i:s, DD/MM/YYYY h:i:s, MM/DD/YYYY h:i:s, YYYY/MM/DD h:i, DD/MM/YYYY h:i and MM/DD/YYYY h:i

24h
YYYY-MM-DD H:i:s, DD-MM-YYYY H:i:s, MM-DD-YYYY H:i:s, YYYY-MM-DD H:i, DD-MM-YYYY H:i, MM-DD-YYYY H:i, YYYY/MM/DD H:i:s, DD/MM/YYYY H:i:s, MM/DD/YYYY H:i:s, YYYY/MM/DD H:i, DD/MM/YYYY H:i and MM/DD/YYYY H:i

Date only formats
YYYY-MM-DD, DD-MM-YYYY, MM-DD-YYYY, YYYY/MM/DD, DD/MM/YYYY and MM/DD/YYYY

Time only format
h:i:s (12h), H:i:s (24h), h:i (12h) and H:i (24h)


-->

<template>
  <div
      v-if="type !== 'hidden' && display && showComponent"
      :title="qaAble ? showIfHasPermission?.toString() : null"
      :class="[containerClasses]"
      :style="{'width':width, 'max_width': width}"
  >
    <label v-if="label !== null && !dateRange" :class="[labelClasses]">{{ label }}
      <span style="color:red">{{ required ? '*' : '' }}</span>
    </label>
    <div v-if="(label !== null || label1 !== null) && dateRange" :class="['rangeLabelContainer', labelClasses]">
      <span class="rangeLabel" :class="separationClassLeft">{{ label }}</span>
      <span style="color:red">{{ required ? '*' : '' }}</span>
      <span class="rangeLabel" :class="separationClassRight">{{ label1 }}</span>
      <span style="color:red">{{ required ? '*' : '' }}</span>
    </div>
    <template v-if="type == 'datetime'">
      <div class="input-group">
        <div :class="[slotClasses]" v-if="hasSlotPrefix">
          <slot name="prefix" v-if="hasSlotPrefix"></slot>
        </div>
        <input
            class="form-control"
            :class="[computedValidationStatus]"
            :type="getType()"
            :placeholder="placeholder"
            v-model="displayInput"
            :required="required"
            :disabled="disabled"
            :readonly="readOnly"
            @click="$emit('onClick')"
            @change="inputchanged"
            @focus="$emit('onFocus')"
            @blur="$emit('onBlur')"
            @keypress="$emit('onKeyPress')"
            :style="{'width': width, 'height': height}"
            autocomplete="new-password"
        />
        <div :class="[slotClasses]" v-if="hasSlotSuffix">
          <slot name="suffix" v-if="hasSlotSuffix"></slot>
        </div>
      </div>
    </template>
    <template v-if="type == 'ks_datetime'">
      <div class="input-group" :class="inputClasses">
        <div :class="[slotClasses]" v-if="hasSlotPrefix">
          <slot name="prefix" v-if="hasSlotPrefix"></slot>
        </div>

        <div :style='{width:width}' class="datetime-picker" v-on:click='calendarClicked($event)'
             v-on:blur='closeCal()'>
          <div>
            <div class="d-flex flex-row justify-content-between" :style="`max-width: ${maxWidth}`" :class="computedValidationStatus">
              <div :class="[separationClassLeft]" v-if="original_show_as == 'input'"
                   :style="{'width': width, 'height': height}">
                <input
                    autocomplete="new-password"
                    v-if="!separateFields"
                    :id="'datetime-input' + id"
                    :type="getType()"
                    class="form-control"
                    :readonly="readonly"
                    :required="required"
                    :value="null"
                    :name='name'
                    v-on:click='openCal'
                    v-on:focus='openCal'
                    v-on:keyup.enter="on_keyup_enter($event)"
                    :style="{'width': width, 'height': height}"
                    @click="$emit('onClick')"
                />
                <!--SEPARATE FIELDS-->
                <ks-flex
                    v-if="separateFields && !calendarOnly"
                    wrap="nowrap"
                    @onClick='openCal()'
                    style="padding: 0 4px; border-radius: .25rem; background: white; min-width: 100%"
                    :style="computedValidationStatus !== 'is-invalid' ? 'border: 1px solid lightgray' : ''"
                    @onBlur="blurred"
                    @onFocus="focused('0')"
                >
                  <input
                      autocomplete="new-password"
                      v-if="!noDate"
                      :id="'datetime-input-month-' + id"
                      :ref="'datetime-input-month-' + id"
                      class="form-control separate-dt text-right"
                      :readonly="readonly"
                      :required="required"
                      v-model="month_bind"
                      :name="name+'_month'"
                      @focus="focused('month')"
                      @keydown.tab.prevent
                      @keyup.shift.prevent
                      @keyup="on_keyup_month($event)"
                      @change="on_keyup_enter_month()"
                      @click="$emit('onClick')"
                      :placeholder="showPlaceHolder ? 'mm' : ''"
                      :style="'width : 24px;'"
                      @blur="blurred"
                  />
                  <ks-text text="/" v-if="!noDate" v-show="showPlaceHolder || (day_bind || month_bind)"
                           :class="'slash'"/>
                  <input
                      autocomplete="new-password"
                      v-if="!noDate"
                      :ref="'datetime-input-day-' + id"
                      :id="'datetime-input-day-' + id"
                      class="form-control separate-dt text-center"
                      :readonly="readonly"
                      :required="required"
                      v-model="day_bind"
                      :name="name+'_day'"
                      @focus="focused('day')"
                      @keydown.tab.prevent
                      @keyup.shift.prevent
                      @keyup="on_keyup_day($event)"
                      @change="on_keyup_enter_day()"
                      @click="$emit('onClick')"
                      :placeholder="showPlaceHolder ? 'dd' : ''"
                      :style="'width : 17px;'"
                      @blur="blurred"
                  />
                  <ks-text text="/" v-if="!noDate" v-show="showPlaceHolder || (day_bind || year_bind)"
                           :class="'slash'"/>
                  <input
                      autocomplete="new-password"
                      v-if="!noDate"
                      :id="'datetime-input-year-' + id"
                      :ref="'datetime-input-year-' + id"
                      class="form-control separate-dt text-left"
                      :readonly="readonly"
                      :required="required"
                      v-model="year_bind"
                      :name="name+'_year'"
                      @focus="focused('year')"
                      @keyup.shift.prevent
                      @keyup.shift.tab.prevent
                      @keydown.tab.prevent
                      @keydown.shift.tab.prevent
                      @keyup="on_keyup_year($event)"
                      @change="on_keyup_enter_year()"
                      @click="$emit('onClick')"
                      :placeholder="showPlaceHolder ? 'yyyy' : ''"
                      style="min-width: 28px;"
                      :style="'width : 28px;'"
                      @blur="blurred"
                  />

                  <input
                      autocomplete="new-password"
                      v-if="formatDateMoment !== 'YYYY-MM-DD' && !noTime"
                      :id="'datetime-input-hour-' + id"
                      :ref="'datetime-input-hour-' + id"
                      class="form-control separate-dt text-right"
                      :readonly="readonly"
                      :required="required"
                      v-model="hour_bind"
                      :name="name+'_hour'"
                      @focus="focused('hour')"
                      @keydown.tab.prevent
                      @keyup.shift.prevent
                      @keyup="on_keyup_hour($event)"
                      @change="on_keyup_enter_hour()"
                      @click="$emit('onClick')"
                      :placeholder="showPlaceHolder ? 'hh' : ''"
                      style="width: 17px;"
                      @blur="blurred"
                  />
                  <ks-text text=":" v-if="formatDateMoment !== 'YYYY-MM-DD' && !noTime"
                           v-show="showPlaceHolder || (hour_bind || min_bind)" :class="'slash'"/>
                  <input
                      autocomplete="new-password"
                      v-if="formatDateMoment !== 'YYYY-MM-DD' && !noTime"
                      :id="'datetime-input-min-' + id"
                      :ref="'datetime-input-min-' + id"
                      class="form-control separate-dt text-left"
                      :readonly="readonly"
                      :required="required"
                      v-model="min_bind"
                      :name="name+'_min'"
                      @focus="focused('min')"
                      @keydown.tab.prevent
                      @keyup.shift.prevent
                      @keyup="on_keyup_min($event)"
                      @change="on_keyup_enter_min()"
                      @click="$emit('onClick')"
                      :placeholder="showPlaceHolder ? 'mm' : ''"
                      style="width: 24px;"
                      @blur="blurred"
                  />
                  <input
                      autocomplete="new-password"
                      v-if="formatDateMoment !== 'YYYY-MM-DD' && !noTime"
                      :id="'datetime-input-ampm-' + id"
                      :ref="'datetime-input-ampm-' + id"
                      class="form-control separate-dt text-left"
                      :readonly="readonly"
                      :required="required"
                      v-model="ampm_bind"
                      :name="name+'_ampm'"
                      @focus="focused('ampm')"
                      @keyup.shift.prevent
                      @keyup.shift.tab.prevent
                      @keyup.tab.prevent
                      @keydown.shift.tab.prevent
                      @keyup="on_keyup_ampm($event)"
                      @change="on_keyup_enter_ampm($event, 0)"
                      @click="$emit('onClick')"
                      :placeholder="showPlaceHolder ? 'AM' : ''"
                      style="width: 24px;"
                      @blur="blurred"
                  />
                </ks-flex>
              </div>
              <template v-if="dateRange">

                <div :class="separationClassRight" v-if="original_show_as == 'input'"
                     :style="{'width': width, 'height': height}">
                  <input
                      autocomplete="new-password"
                      v-if="!separateFields"
                      :id="'datetime-input-end-' + id"
                      :type="getType()"
                      class="form-control"
                      :readonly="readonly"
                      :required="required"
                      :value="null"
                      :name="name+'_end'"
                      v-on:click='openCal(1, 1)'
                      v-on:focus='openCal(1, 1)'
                      v-on:keyup.enter="on_keyup_enter($event)"
                      :style="{'width': width, 'height': height}"
                      @click="$emit('onClick')"
                  />


                  <ks-flex
                      v-if="separateFields"
                      wrap="nowrap"
                      @onClick='openCal(1, 1)'
                      style="padding: 0 4px; border: 1px solid lightgray; border-radius: .25rem; background: white; min-width: 100%"
                      @onBlur="blurred"
                      @onFocus="focused('1')"
                  >
                    <input
                        autocomplete="new-password"
                        v-if="!noDate"
                        :id="'datetime-input-month1-' + id"
                        :ref="'datetime-input-month1-' + id"
                        class="form-control separate-dt text-right"
                        :readonly="readonly"
                        :required="required"
                        v-model="month_bind1"
                        :name="name+'_month1'"
                        @focus="focused('month1')"
                        @keydown.tab.prevent
                        @keyup.shift.prevent
                        @keyup="on_keyup_month($event, 1)"
                        @change="on_keyup_enter_month($event, 1)"
                        @click="$emit('onClick')"
                        :placeholder="showPlaceHolder ? 'mm' : ''"
                        :style="'width : 24px;'"
                        @blur="blurred"
                    />
                    <ks-text text="/" v-if="!noDate" v-show="showPlaceHolder || (day_bind1 || month_bind1)"
                             :class="'slash'"/>
                    <input
                        autocomplete="new-password"
                        v-if="!noDate"
                        :ref="'datetime-input-day1-' + id"
                        :id="'datetime-input-day1-' + id"
                        class="form-control separate-dt text-center"
                        :readonly="readonly"
                        :required="required"
                        v-model="day_bind1"
                        :name="name+'_day1'"
                        @focus="focused('day1')"
                        @keydown.tab.prevent
                        @keyup.shift.prevent
                        @keyup="on_keyup_day($event, 1)"
                        @change="on_keyup_enter_day($event, 1)"
                        @click="$emit('onClick')"
                        :placeholder="showPlaceHolder ? 'dd' : ''"
                        :style="'width : 17px;'"
                        @blur="blurred"
                    />
                    <ks-text text="/" v-if="!noDate" v-show="showPlaceHolder || (day_bind1 || year_bind1)"
                             :class="'slash'"/>
                    <input
                        autocomplete="new-password"
                        v-if="!noDate"
                        :id="'datetime-input-year1-' + id"
                        :ref="'datetime-input-year1-' + id"
                        class="form-control separate-dt text-left"
                        :readonly="readonly"
                        :required="required"
                        v-model="year_bind1"
                        :name="name+'_year1'"
                        @focus="focused('year1')"
                        @keyup.shift.prevent
                        @keyup.shift.tab.prevent
                        @keydown.tab.prevent
                        @keydown.shift.tab.prevent
                        @keyup="on_keyup_year($event, 1)"
                        @change="on_keyup_enter_year($event, 1)"
                        @click="$emit('onClick')"
                        :placeholder="showPlaceHolder ? 'yyyy' : ''"
                        style="min-width: 28px;"
                        :style="'width : 28px;'"
                        @blur="blurred"
                    />
                    <input
                        autocomplete="new-password"
                        v-if="formatDateMoment !== 'YYYY-MM-DD' && !noTime"
                        :id="'datetime-input-hour1-' + id"
                        :ref="'datetime-input-hour1-' + id"
                        class="form-control separate-dt text-right"
                        :readonly="readonly"
                        :required="required"
                        v-model="hour_bind1"
                        :name="name+'_hour1'"
                        @focus="focused('hour1')"
                        @keydown.tab.prevent
                        @keyup.shift.prevent
                        @keyup="on_keyup_hour($event, 1)"
                        @change="on_keyup_enter_hour($event, 1)"
                        @click="$emit('onClick')"
                        :placeholder="showPlaceHolder ? 'hh' : ''"
                        style="width: 17px;"
                        @blur="blurred"
                    />
                    <ks-text text=":" v-if="formatDateMoment !== 'YYYY-MM-DD' && !noTime"
                             v-show="showPlaceHolder || (hour_bind1 || min_bind1)" :class="'slash'"/>
                    <input
                        autocomplete="new-password"
                        v-if="formatDateMoment !== 'YYYY-MM-DD' && !noTime"
                        :id="'datetime-input-min1-' + id"
                        :ref="'datetime-input-min1-' + id"
                        class="form-control separate-dt text-left"
                        :readonly="readonly"
                        :required="required"
                        v-model="min_bind1"
                        :name="name+'_min1'"
                        @focus="focused('min1')"
                        @keydown.tab.prevent
                        @keyup.shift.prevent
                        @keyup="on_keyup_min($event, 1)"
                        @change="on_keyup_enter_min($event, 1)"
                        @click="$emit('onClick')"
                        :placeholder="showPlaceHolder ? 'mm' : ''"
                        style="width: 24px;"
                        @blur="blurred"
                    />
                    <input
                        autocomplete="new-password"
                        v-if="formatDateMoment !== 'YYYY-MM-DD' && !noTime"
                        :id="'datetime-input-ampm1-' + id"
                        :ref="'datetime-input-ampm1-' + id"
                        class="form-control separate-dt text-left"
                        :readonly="readonly"
                        :required="required"
                        v-model="ampm_bind1"
                        :name="name+'_ampm1'"
                        @focus="focused('ampm1')"
                        @keyup.shift.prevent
                        @keyup.shift.tab.prevent
                        @keyup.tab.prevent
                        @keydown.shift.tab.prevent
                        @keyup="on_keyup_ampm($event, 1)"
                        @change="on_keyup_enter_ampm($event, 1)"
                        @click="$emit('onClick')"
                        :placeholder="showPlaceHolder ? 'AM' : ''"
                        style="width: 24px;"
                        @blur="blurred"
                    />
                  </ks-flex>
                </div>
              </template>

              <div v-if="original_show_as == 'days_remaining'"
                   :readonly="true"
                   :id="'datetime-input' + id"
                   :name='name'
                   v-on:click='openCal'
                   :class="{'hovered': hovered, classes: true}"
                   autocomplete='off'
              >
                <span v-if="days_remaining === 'No Date'">
                  <span v-show="!hovered"></span>
                  <span v-show="hovered">{{ days_remaining }}</span>
                </span>
                <span v-else>
                {{ days_remaining }}
                </span>
              </div>

              <div v-if="original_show_as == 'plain_date'"
                   :readonly="true"
                   :id="'datetime-input' + id"
                   :name='name'
                   v-on:click='openCal'
                   :class="{'hovered': hovered, classes: true}"
                   autocomplete='off'
              >
                <span>
                 {{ input ? formatPlainDate(input) : addText }}
                </span>
              </div>

              <span v-if="icon"><i :class="icon"></i></span>
            </div>
            <div :class="calendarOnly ? '' : 'calender-div'" v-if="!hideCal || calendarOnly">
              <div :class='{noDisplay: hideDate}'>
                <div class='year-month-wrapper d-flex flex-row justify-content-between' v-if="!noDate">
                  <div v-if="showRelativeField">
                    <select v-model="relativeTime" class="form-control" @change="setValue">
                      <option value="today">Today</option>
                      <option value="last_week">Last Week</option>
                      <option value="last_month">Last Month</option>
                      <option value="last_year">Last Year</option>
                    </select>
                  </div>
                  <div class='month-setter d-flex flex-row justify-content-between'>
                    <button class="nav-l" type='button' v-on:click='leftYear'>
                      <i class="fas fa-caret-left"></i>
                    </button>
                    <span class='year' v-if="showDropdownYear">
                      <select class="form-select" v-model="year" @change="updateCalendar">
                        <option :value="y" v-for="(y, index) in years">{{ y }}</option>
                      </select>
                    </span>
                    <span class='year' v-else>{{ year }}</span>
                    <button class="nav-r" type='button' v-on:click='rightYear'><i
                        class="fas fa-caret-right"></i></button>
                  </div>
                  <div class='month-setter d-flex flex-row justify-content-between'>
                    <button class="nav-l" type='button' v-on:click='leftMonth'><i
                        class="fas fa-caret-left"></i>
                    </button>
                    <span class='month' v-if="showDropdownMonth">
                      <select class="form-select" v-model="monthIndex" @change="updateCalendar">
                        <option :value="index" v-for="(m, index) in months">{{ m }}</option>
                      </select>
                    </span>
                    <span class='month' v-else>{{ month }}</span>
                    <button class="nav-r" type='button' v-on:click='rightMonth'><i
                        class="fas fa-caret-right"></i></button>
                  </div>
                </div>
                <div class='headers' v-if="!noDate">
                  <span class='days' v-for="port in days" :key="port">{{ port }}</span>
                </div>
                <div v-if="!noDate">
                  <div class="week" v-for="(week, weekIndex) in weeks" :key="weekIndex">
                    <span v-for="(day, dayIndex) in week" :key="dayIndex"
                          v-on:mouseover='dateRange && ((input && isRangeEndDate && !input1) || (!input && input1)) ? setDay(weekIndex*7 + dayIndex, day, true)
                          : null'
                          v-on:click='isEnableDate(day) ? setDay(weekIndex * 7 + dayIndex, day) : null'
                          :class="{
                        'port': isEnableDate(day),
                        'port-disabled': !isEnableDate(day),
                        'activePort': !dateRange ? (weekIndex * 7 + dayIndex) === activePort: isActiveRangeDate(day, 'start') || isActiveRangeDate(day, 'end'),
                        'activeRangePort': isActiveRangeDate(day, 'between', false),
                        'errorRangePort': isActiveRangeDate(day, 'between', true),
                        'today': isToday(day)}"
                    >
                      <span :class="{'gray':day.month}">{{ day.day }}</span>
                    </span>
                  </div>
                </div>
              </div>
              <div class="d-flex flex-column justify-content-center" style="width: 100%" v-if="!noTime">
                <ks-flex justify="center" :class='{noDisplay: hideTime}'>
                  <button type="button" class="btn btn-link" @click="clearTime()" v-if="allowNoTime">No Time</button>
                  <div
                      class='hour-selector'

                  >
                    <!--                      :class="{'selector-width-on': hourSelectorVisible}"-->
                    <div v-on:click='showHourSelector' id='j-hour' class="p-1">
                      {{
                        periodStyle === 12 && hour > 12
                            ? hour - 12 : hour
                      }}
                    </div>
                    <div class='scroll-hider selector-width-on-hour' ref='hourScrollerWrapper'
                         :class='{showSelector: hourSelectorVisible}'
                         style="height: 240px; position: absolute; top: 0; left: 0;"
                    >
                      <!--                      <ul ref='hourScroller'>
                                              <li v-for="(h, index) in hours" :key="index"
                                                  :class='{active: index === hourIndex}'
                                                  v-on:click='setHour(index, true)'>{{ h }}
                                              </li>
                                            </ul>-->
                      <div>HOUR:</div>
                      <ks-flex ref='hourScroller'>
                        <div v-for="(h, index) in hours" :key="index"
                             :class='{active: index === hourIndex}'
                             v-on:click='setHour(index, true)'
                             style="font-size: x-large"
                        >
                          {{ h }}
                        </div>
                      </ks-flex>
                    </div>
                  </div>
                  <div class='time-separator'>
                    <span>:</span>
                  </div>
                  <div class='minute-selector'
                  >
                    <div v-on:click='showMinuteSelector' id='j-minute' class="p-1">{{ minute }}</div>
                    <div class='scroll-hider selector-width-on-minute' ref='minuteScrollerWrapper'
                         :class='{showSelector: minuteSelectorVisible}'
                         style="height: 600px; position: absolute; top: 0; left: -25px;"
                    >
                      <!--                      <ul ref='minuteScroller'>
                                              <li v-for="(m, index) in minutes" :key="index"
                                                  :class='{active: index === minuteIndex}'
                                                  v-on:click='setMinute(index, true)'>
                                                {{ m }}
                                              </li>
                                            </ul>-->

                      <div>MINUTE:</div>
                      <ks-flex>
                        <div v-for="(m, index) in minutes" :key="index"
                             :class='{active: index === minuteIndex}'
                             v-on:click='setMinute(index, true)'
                             style="font-size: x-large"
                             :style="isDivisibleByFive(m)"
                        >
                          {{ m }}
                        </div>
                      </ks-flex>
                    </div>
                  </div>
                  <div class='time-separator' v-if='periodStyle === 12'>
                    <span>:</span>
                  </div>
                  <div class='minute-selector' v-if='periodStyle === 12'>
                    <div v-on:click='changePeriod' class="p-1">{{ period }}</div>
                  </div>
                </ks-flex>

              </div>
              <div v-else>
                <ks-button color="link" @onClick="$emit('addTime')" label="Add Time" v-if="showAddTime"/>
              </div>
              <div class="d-flex flex-row justify-content-between" style="border-top: 1px solid #ced4da;">
                <ks-button color="link" @onClick='clearDate(false)' v-if="enableClearDate">Clear</ks-button>
                <ks-button color="link" label="Submit" v-if="showSubmit" @onClick="submit"/>
              </div>
            </div>
          </div>
        </div>

        <div :class="[slotClasses]" v-if="hasSlotSuffix">
          <slot name="suffix" v-if="hasSlotSuffix"></slot>
        </div>
      </div>
    </template>
    <small class="form-text text-muted" v-if="helpText">{{ helpText }}</small>
    <div class="valid-feedback" style="display:block !important" v-if="computedValidationStatus === 'is-valid'">
      <ul>
        <li v-for="(text, index) in validText" :key="_uid + 'success_' + index" style="font-size: small">{{ text }}</li>
      </ul>
    </div>
    <div class="invalid-feedback" style="display:block !important" v-if="computedValidationStatus === 'is-invalid'">
      <ul>
        <li v-for="(text, index) in invalidText" :key="_uid+'error_'+index" style="font-size: small">{{ text }}</li>
      </ul>
    </div>
  </div>
  <div v-else-if="display">
    <input type="hidden" v-model="displayInput" autocomplete="new-password">
  </div>
</template>

<script>

import startOfMonth from 'date-fns/startOfMonth';
import endOfMonth from 'date-fns/endOfMonth';
import eachDay from 'date-fns/eachDayOfInterval';
import getDay from 'date-fns/getDay';
import format from 'date-fns/format';
import startOfDay from 'date-fns/startOfDay';
import isEqual from 'date-fns/isEqual';
import differenceInCalendarDays from 'date-fns/differenceInCalendarDays';
import differenceInHours from 'date-fns/differenceInHours';
import differenceInMinutes from 'date-fns/differenceInMinutes';
import parseISO from 'date-fns/parseISO';
import checkPermissions from '../../mixins/checkPermissions';
import getMonth from 'date-fns/getMonth';
import moment from 'moment';

const days = ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'];
const AM   = 'AM'
const PM   = 'PM'
export default {
  name:     'datetime-input-field',
  mixins:   [checkPermissions],
  props:    {

    calendarOnly:          {
      type:    Boolean,
      default: false
    },
    allowNoTime:           {
      type:    Boolean,
      default: true
    },
    onlyUpdateOnSubmit:    {
      type:    Boolean,
      default: false
    },
    showSubmit:            {
      type:    Boolean,
      default: true
    },
    addText:               {
      type:    String,
      default: 'Add'
    },
    clearTheDate:          {
      type:    Boolean,
      default: false
    },
    separateFields:        {
      type:    Boolean,
      default: true
    },
    maxWidth:              {
      type:    String,
      default: '152px'
    },
    separationClassLeft:   {
      type:    String,
      default: null
    },
    separationClassRight:  {
      type:    String,
      default: null
    },
    debug:                 {
      type:    Boolean,
      default: false
    },
    showRelativeField:     {
      type:    Boolean,
      default: false
    },
    focus:                 {
      type:    Boolean,
      default: false
    },
    validateDateRange:     {
      type:    Boolean,
      default: true
    },
    dateRange:             {
      type:    Boolean,
      default: false
    },
    minDate:               {
      type:    String,
      default: null
    },
    maxDate:               {
      type:    String,
      default: null
    },
    minYear:               {
      type:    Number,
      default: parseInt(moment().format('YYYY')) - 2,
    },
    maxYear:               {
      type:    Number,
      default: parseInt(moment().format('YYYY')) + 2,
    },
    showDropdownYear:      {
      type:    Boolean,
      default: true
    },
    showDropdownMonth:     {
      type:    Boolean,
      default: false
    },
    icon:                  {
      type:    String,
      default: null
    },
    displayText:           {
      type:    String,
      default: null
    },
    index:                 {
      type:    Number,
      default: null
    },
    validation:            {
      default: null
    },
    size:                  {
      type:    String, //sm-lg-md
      default: null
    },
    inLine:                {
      type:    Boolean,
      default: false
    },
    inlineLabelColClass:   {
      type:    String,
      default: 'col-4'
    },
    inlineInputColClass:   {
      type:    String,
      default: 'col-8 pl-1 pb-2 inline-input'
    },
    dataSource:            {
      type:     String,
      required: false
    },
    dataSource1:           {
      type:     String,
      required: false
    },
    altDataSource:         {
      type:     String,
      required: false
    },
    defaultValue:          {
      default: null
    },
    label:                 {
      type:    String,
      default: null
    },
    label1:                {
      type:    String,
      default: null
    },
    disabled:              {
      type:    Boolean,
      default: false
    },
    type:                  {
      type:    String,
      default: "ks_datetime",
    },
    rows:                  {
      type: Number
    },
    placeholder:           {
      type: String
    },
    helpText:              {
      type:    String,
      default: null
    },
    readOnly:              {
      type:    Boolean,
      default: false
    },
    display:               {
      type:    Boolean,
      default: true
    },
    classes:               {
      type:    String,
      default: null
    },
    field:                 {
      type:    String,
      default: '',
    },
    date_id:               {
      type:    String,
      default: '',
    },
    show_as:               {
      type:    String,
      default: 'input',
    },
    plainDateDisplayFormat:               {
      type:    String,
      default: 'YYYY-MM-DD hh:mm A',
    },
    hovered:               {
      type:    Boolean,
      default: false,
    },
    formatDate:            {
      type:    String,
      default: 'YYYY-MM-DD h:i',
    },
    formatDateMoment:      {
      default: 'YYYY-MM-DD hh:mm A',
    },
    name:                  {
      type: String
    },
    width:                 {
      type: String
    },
    height:                {
      type: String
    },
    required:              {
      type:    Boolean,
      default: false
    },
    readonly:              {
      type:    Boolean,
      default: false
    },
    autoFocusRangeEndDate: {
      type:    Boolean,
      default: true
    },
    enableClearTime:       {
      type:    Boolean,
      default: false
    },
    enableClearDate:       {
      type:    Boolean,
      default: true
    },
    noTime:                {
      type:    Boolean,
      default: true
    },
    noDate:                {
      type:    Boolean,
      default: false
    },
    showAddTime:           {
      type:    Boolean,
      default: false
    },
    firstDayOfWeek:        {
      default:   0,
      validator: function (value) {
        try {
          const val = parseInt(value, 10)
          return val >= 0 && val <= 1
        } catch (e) {
          console.warn(e.message)
          return false
        }
      },
      message:   'Only 0 (Sunday) and 1 (Monday) are supported.'
    },
  },
  watch:    {
    hour:                 function () {
      this.hour = this.hour === '00' ? this.hour = '12' : this.hour;
    },
    clearTheDate:         function (newVal, oldVal) {
      if (newVal) {
        this.clearDate(true);
      }
    },
    focus:                function (newVal, oldVal) {
      if (newVal) {
        document.getElementById(`datetime-input${this.id}`).focus();
      }
    },
    openDateTimePickerId: function (newVal, oldVal) {
      if (this.id !== this.openDateTimePickerId) {
        if (!this.hideCal) {
          this.closeCal();
        }
      }
    },
    defaultValue:         function (newVal, oldVal) {
      if (newVal) {
        this.input = newVal;
      }
    },
    input:                {
      handler(newVal, oldVal) {
        this.setInput(newVal, 0);
      },
      deep: true
    },
    input1:               function (newVal, oldVal) {
      this.setInput(newVal, 1);
    },
  },
  computed: {
    qaAble:               {
      get: () => {
        return app.store.state.ks_app.global_data.qaAble;
      }
    },
    openDateTimePickerId: {
      get: () => {
        return app.store.state.ks_app.global_data.openDateTimePickerId;
      },
      set: (value) => {
        app.store.commit('ks_app/global_data/setOpenDateTimePickerId', value);
      }
    },
    validMinYear() {
      return this.minYear <= this.maxYear ? this.minYear : parseInt(moment().year());
    },
    validMaxYear() {
      return this.maxYear >= this.maxYear ? this.maxYear : parseInt(moment().year());
    },
    years() {
      let years = [];
      for (let i = this.validMinYear; i <= this.validMaxYear; i++) {
        years.push(i);
      }
      return years;
    },
    isCurrentMonth() {
      let currentMonth = getMonth(this.todayTimeStamp);
      return this.months[currentMonth] == this.month && this.todayTimeStamp.getFullYear() == this.year;
    },
    days_remaining() {
      let return_val = "No Date";
      if (this.input) {
        let diff = differenceInCalendarDays(new Date(parseISO(this.input)), new Date());
        if (diff < 0) {
          return_val = "In Progress";
        } else if (diff == 0) {

          diff = differenceInHours(new Date(parseISO(this.input)), new Date());
          if (diff > 0) {
            return_val = diff + (diff == 1 ? " hour" : " hours"); /*"Today " +*/
          } else {
            return_val = (diff * -1) + (diff == -1 ? " hr ago" : " hrs ago");
          }
          if (diff == 0) {
            diff = differenceInMinutes(new Date(parseISO(this.input)), new Date());
            if (diff > 0) {
              return_val = diff + (diff == 1 ? " minute" : " minutes"); /*"Today " +*/
            } else {
              return_val = (diff * -1) + " min ago";
            }
          }
          //TODO set this to look at the noTime instead -- (this.hour == "00" && this.minute == "00") ||
          if (this.noTime) {
            return_val = "Today";
          }
        } else if (diff > 8) {
          return_val = diff + " days";
        } else if (diff === 1) {
          return_val = "Tomorrow";
        } else {
          return_val = format(new Date(parseISO(this.input)), "iiii")
        }
      }
      return this.displayText ? this.displayText : return_val;
    },
    inputType() {
      return this.$parent.type;
    },
    displayInput:  {
      get() {
        let dFormat = this.formatDateMoment === 'YYYY-MM-DD' || this.noTime ? 'YYYY-MM-DD' : "YYYY-MM-DD HH:mm";
        let format  = moment(this.input).format(dFormat);
        return format.replace(' ', 'T');
      },
      set(newval) {
        if (this.timer) clearTimeout(this.timer);
        this.timer = setTimeout(() => {
          let newDate = new Date(newval);
          this.input  = moment(newDate).format(this.formatDateMoment)
        }, 1000)
      }
    },
    displayInput1: {
      get() {
        let dFormat = this.formatDateMoment === 'YYYY-MM-DD' || this.noTime ? 'YYYY-MM-DD' : "YYYY-MM-DD HH:mm";
        let format  = moment(this.input1).format(dFormat);
        return format.replace(' ', 'T');
      },
      set(newval) {
        if (this.timer) clearTimeout(this.timer);
        this.timer = setTimeout(() => {
          let newDate = new Date(newval);
          this.input1 = moment(newDate).format(this.formatDateMoment)
        }, 1000)
      }
    },
    input:         {
      get() {
        if (this.inputType === 'list') {
          if (this.dataSource && this.altDataSource) {
            if (this.hovered) {
              return this.$parent.data_provider_ref[this.inputType][this.index][this.dataSource];
            } else {
              return this.$parent.data_provider_ref[this.inputType][this.index][this.altDataSource];
            }
          } else if (this.dataSource && !this.altDataSource) {
            return this.$parent.data_provider_ref[this.inputType][this.index][this.dataSource];
          } else {
            return this.date;
          }
        } else {
          if (this.dataSource) {
            return this.$parent.data_provider_ref[this.inputType][this.dataSource];
          } else {
            return this.date;
          }
        }
      },
      set(newval) {
        if (this.inputType === 'list') {
          if (this.dataSource) {
            this.$set(this.$parent.data_provider_ref[this.inputType][this.index], this.dataSource, newval);
          } else {
            this.date = newval;
          }
        } else {
          if (this.dataSource) {
            this.$set(this.$parent.data_provider_ref[this.inputType], this.dataSource, newval);
          } else {
            this.date = newval;
          }
        }

        if (this.separateFields) this.setSeparateDate("2");
      }
    },
    input1:        {
      get() {
        if (this.dateRange && this.dataSource1) {
          if (this.inputType === 'list') {
            return this.$parent.data_provider_ref[this.inputType][this.index][this.dataSource1];
          } else {
            return this.$parent.data_provider_ref[this.inputType][this.dataSource1];
          }
        } else {
          return null;
        }
      },
      set(newval) {
        if (this.dateRange && this.dataSource1) {
          if (this.inputType === 'list') {
            this.$set(this.$parent.data_provider_ref[this.inputType][this.index], this.dataSource1, newval);
          } else {
            this.$set(this.$parent.data_provider_ref[this.inputType], this.dataSource1, newval);
          }
        }
        if (this.separateFields) this.setSeparateDate1("3");
      }
    },
    computedValidationStatus() {
      return this.isValid === null ? "none" : this.isValid === true ? "" : "is-invalid"; /*is-valid*/
    },
    containerClasses() {
      return `${this.inLine ? 'row' : ''} ${this.classes ? this.classes : ''}`;
    },
    labelClasses() {
      let sizeClass   = this.size ? `col-form-label-${size}` : '';
      let inlineClass = this.inLine ? `${this.inlineLabelColClass} col-form-label` : ''
      return `${sizeClass} ${inlineClass}`;
    },
    inputClasses() {
      let sizeClass   = this.size ? `form-control-${size}` : '';
      let inlineClass = this.inLine ? `${this.inlineInputColClass}` : '';
      return `${sizeClass} ${inlineClass}`;
    },
    hasSlotPrefix() {
      return !!this.$slots.prefix;
    },
    hasSlotSuffix() {
      return !!this.$slots.suffix;
    },
    slotClasses() {
      return this.hasSlotPrefix ? 'input-group-prepend' : this.hasSlotSuffix ? 'input-group-append' : null;
    },
    original_show_as:         function () {
      return this.hideCal ? this.show_as : 'input';
    },
    normalizedFirstDayOfWeek: function () {
      return parseInt(this.firstDayOfWeek, 10);
    },
    ports:                    {
      get: function () {
        let p = []
        if (this.portsHolder.length === 0) {
          for (let i = 0; i < 42; i++) {
            p.push('')
          }
        } else {
          p = this.portsHolder
        }
        return p
      },
      set: function (newValue) {
        this.portsHolder = newValue
      }
    },
    month() {
      return this.months[this.monthIndex]
    },
    dateTime() {
      return this.timeStamp.getFullYear() + '-' + (this.timeStamp.getMonth() + 1) + '-' + this.timeStamp.getUTCDay()
    },
    minutes() {
      let arr = []
      for (let i = 0; i < 60; i++) {
        i < 10 ? arr.push('0' + i) : arr.push('' + i)
      }
      return arr
    },
    hours() {
      let arr = []
      if (this.periodStyle === 24) {
        for (let i = 0; i < this.periodStyle; i++) {
          i < 10 ? arr.push('0' + i) : arr.push('' + i)
        }
      } else {
        for (let i = 1; i <= this.periodStyle; i++) {
          i < 10 ? arr.push('0' + i) : arr.push('' + i)
        }
      }
      return arr
    },
    dateFormat() {
      let f              = 'YYYY-MM-DD h:i:s'
      let allowedFormats = [
        'YYYY-MM-DD h:i:s', 'DD-MM-YYYY h:i:s', 'MM-DD-YYYY h:i:s',
        'YYYY-MM-DD h:i', 'DD-MM-YYYY h:i', 'MM-DD-YYYY h:i',
        'YYYY-MM-DD H:i:s', 'DD-MM-YYYY H:i:s', 'MM-DD-YYYY H:i:s',
        'YYYY-MM-DD H:i', 'DD-MM-YYYY H:i', 'MM-DD-YYYY H:i',
        'YYYY-MM-DD', 'DD-MM-YYYY', 'MM-DD-YYYY',
        'YYYY/MM/DD', 'DD/MM/YYYY', 'MM/DD/YYYY',
        'h:i:s', 'H:i:s', 'h:i', 'H:i',
        'YYYY/MM/DD h:i:s', 'DD/MM/YYYY h:i:s', 'MM/DD/YYYY h:i:s',
        'YYYY/MM/DD h:i', 'DD/MM/YYYY h:i', 'MM/DD/YYYY h:i',
        'YYYY/MM/DD H:i:s', 'DD/MM/YYYY H:i:s', 'MM/DD/YYYY H:i:s',
        'YYYY/MM/DD H:i', 'DD/MM/YYYY H:i', 'MM/DD/YYYY H:i'
      ]
      if (this.formatDate) {
        f = this.formatDate
      }
      if (allowedFormats.indexOf(f) < 0) {
        console.warn('Invalid date format supplied. Current default date format is being used.')
        // return default date format if date format is invalid
        return 'YYYY-MM-DD h:i:s'
      } else {
        return f
      }
    },
    hideTime() {
      return this.dateFormat.indexOf('h:i:s') === -1
          && this.dateFormat.indexOf('H:i:s') === -1
          && this.dateFormat.indexOf('h:i') === -1
          && this.dateFormat.indexOf('H:i') === -1
    },
    hideDate() {
      return this.dateFormat === 'h:i:s' || this.dateFormat === 'H:i:s'
          || this.dateFormat === 'h:i' || this.dateFormat === 'H:i'
    },
    data_provider_ref() {
      return this.$parent.data_provider_ref ? this.$parent.data_provider_ref : {};
    },
    dataProvider() {
      return this.$parent.dataProvider ? this.$parent.dataProvider : null;
    }
  },
  mounted() {
    this.id = this._uid;
    if (this.defaultValue) this.$set(this.$parent.data_provider_ref[this.inputType], this.dataSource, this.defaultValue);
    this.$emit('onMounted', this);
    setTimeout(() => {
      this.$set(this.$parent.data_provider_ref.inputs, this.dataSource, this);
    }, 500);

  },
  methods: {
    formatPlainDate(date) {
      if (date) {
        return moment(date).format(this.plainDateDisplayFormat);
      }
    },
    isDivisibleByFive(val) {
      let m = parseInt(val);
      if (m % 15 === 0) {
        return 'color: black';
      }
      return false;
    },
    submit() {
      this.$emit('onChange', this);
      this.hideCal = true
    },
    blurred() {
      this.showPlaceHolder = false;
    },
    setInput(newVal, which = 0) {
      if (this.defaultValue !== null && (newVal === undefined || newVal === null)) {
        this.input = this.defaultValue;
      }
      if (newVal && moment(new Date(newVal)).isValid) {
        this.validate_input();
        try {
          this.timeStamp = this.makeDateObject(newVal);
        } catch (e) {
          console.warn(e.message + '. Current date is being used.');
          this.timeStamp = new Date();
        }
        this.year       = this.timeStamp.getFullYear();
        this.monthIndex = this.timeStamp.getMonth();
        this.deadDays   = getDay(this.monthIndex) + 1;
        this.day        = this.timeStamp.getDate();
        this.hour       = this.timeStamp.getHours();
        this.hour       = parseInt(this.hour) < 10 ? '0' + this.hour : '' + this.hour;

        this.minute = this.timeStamp.getMinutes();
        this.minute = parseInt(this.minute) < 10 ? '0' + this.minute : '' + this.minute;
        this.updateCalendar();
        this.date = newVal == null ? '' : newVal;
        this.setAmPm();
      } else {
        this.date = null;
        // this.date = oldVal == null ? '' : oldVal;
      }

      if (this.separateFields) {
        if (which !== 1) this.setSeparateDate("1");
        if (which === 1) this.setSeparateDate1("1");
      }
    },
    focused(what) {
      this.$emit('onFocus');
      if (what === '0') what = "month";
      if (what === '1') what = "month1";
      this.showPlaceHolder = true;
      this.$refs[`datetime-input-${what}-${this.id}`].select();
    },
    setSeparateDate(where = null) {
      //set the local bindable values
      let date = this.date;

      if (!date) {
        this.year_bind  = null;
        this.month_bind = null;
        this.day_bind   = null;
        this.hour_bind  = null;
        this.min_bind   = null;
        this.ampm_bind  = null;
        return;
      }
      let theDate   = date.split(" ")[0];
      let theTime   = date.split(" ")[1];
      let splitDate = theDate.split('-');
      let splitTime = theTime ? theTime.split(':') : null;

      this.year_bind  = splitDate[0];
      this.month_bind = splitDate[1];
      this.day_bind   = splitDate[2];
      this.hour_bind  = splitTime ? (parseInt(splitTime[0]) < 12 ? splitTime[0] : parseInt(splitTime[0]) - 12) : null;
      this.hour_bind  = this.hour_bind == '00' ? '12' : this.hour_bind;
      if (parseInt(this.hour_bind) < 10 && this.hour_bind.length < 2) {
        this.hour_bind = `0${this.hour_bind}`;
      }
      this.min_bind  = splitTime ? (splitTime[1]) : null;
      this.ampm_bind = splitTime ? (splitTime[0] < 12 ? "AM" : "PM") : null;
    },
    setSeparateDate1() {

      //set the local bindable values
      let date = this.date;

      if (!date) {
        this.year_bind1  = null;
        this.month_bind1 = null;
        this.day_bind1   = null;
        this.hour_bind1  = null;
        this.min_bind1   = null;
        this.ampm_bind1  = null;
        return;
      }
      let theDate   = date.split(" ")[0];
      let theTime   = date.split(" ")[1];
      let splitDate = theDate.split('-');
      let splitTime = theTime ? theTime.split(':') : null;

      this.year_bind1  = splitDate[0];
      this.month_bind1 = splitDate[1];
      this.day_bind1   = splitDate[2];
      this.hour_bind1  = splitTime ? (splitTime[0] < 12 ? splitTime[0] : parseInt(splitTime[0]) - 12) : null;
      this.hour_bind1  = this.hour_bind1 == '00' ? '12' : this.hour_bind1;

      if (parseInt(this.hour_bind1) < 10) {
        this.hour_bind1 = `0${this.hour_bind1}`;
      }

      this.min_bind1  = splitTime ? (splitTime[1]) : null;
      this.ampm_bind1 = splitTime ? (splitTime[0] < 12 ? "AM" : "PM") : null;
    },
    setTimeFromSeparate(which = 0, where = null, update = false) {

      let theDate = null;
      let theTime = null;
      if (which === 0) {
        if (this.day_bind && this.month_bind && this.year_bind) {
          theDate = `${this.year_bind}-${this.month_bind}-${this.day_bind}`;
        }
        if (this.hour_bind && this.min_bind) {
          theTime = `${this.ampm_bind && this.ampm_bind === "PM" ? (parseInt(this.hour_bind) < 12 ? parseInt(this.hour_bind) + 12 : parseInt(this.hour_bind)) : this.hour_bind}:${this.min_bind}:00`
        }
      } else {
        if (this.day_bind1 && this.month_bind1 && this.year_bind1) {
          theDate = `${this.year_bind1}-${this.month_bind1}-${this.day_bind1}`;
        }
        if (this.hour_bind1 && this.min_bind1) {
          theTime = `${this.ampm_bind1 && this.ampm_bind1 === "PM" ? (parseInt(this.hour_bind1) < 12 ? parseInt(this.hour_bind1) + 12 : parseInt(this.hour_bind1)) : this.hour_bind1}:${this.min_bind1}:00`
        }
      }
      if (theDate) {
        this.date = theDate + (theTime ? ' ' + theTime : '');
        let send  = {
          'target': {
            'value': theDate + (theTime ? ' ' + theTime : '')
          }
        }

        this.on_keyup_enter(send, false);
      }
    },

    on_keyup_month(event, which = 0) {
      if (event.code === "ArrowLeft" || event.code === "ArrowRight") return;
      if (event.key === "Shift") return;
      if (which === 0) {
        if (this.month_bind?.length > 1 || (event.code === "Tab" && !event.shiftKey)) {
          this.$refs[`datetime-input-day-${this.id}`].focus();
          this.$refs[`datetime-input-day-${this.id}`].select();
        }
      } else {
        if (this.month_bind1?.length > 1 || (event.code === "Tab" && !event.shiftKey)) {
          this.$refs[`datetime-input-day1-${this.id}`].focus();
          this.$refs[`datetime-input-day1-${this.id}`].select();
        }
      }
    },
    on_keyup_day(event, which = 0) {

      // let insert = which === 1 ? which.toString : '';
      if (event.code === "ArrowLeft" || event.code === "ArrowRight") return;
      if (event.key === "Shift") return;
      if (which === 0) {
        if (event.code === "Tab" && event.shiftKey) {
          this.$refs[`datetime-input-month-${this.id}`].focus();
          this.$refs[`datetime-input-month-${this.id}`].select();
          return;
        }
        if (this.day_bind?.length > 1 || (event.code === "Tab" && !event.shiftKey)) {
          this.$refs[`datetime-input-year-${this.id}`].focus();
          this.$refs[`datetime-input-year-${this.id}`].select();
        }
      } else {
        if (event.code === "Tab" && event.shiftKey) {
          this.$refs[`datetime-input-month1-${this.id}`].focus();
          this.$refs[`datetime-input-month1-${this.id}`].select();
          return;
        }
        if (this.day_bind1?.length > 1 || (event.code === "Tab" && !event.shiftKey)) {
          this.$refs[`datetime-input-year1-${this.id}`].focus();
          this.$refs[`datetime-input-year1-${this.id}`].select();
        }
      }
    },
    on_keydown_year(event) {

      return;
      if (this.formatDateMoment !== 'YYYY-MM-DD' && !this.noTime) event.preventDefault();
    },
    on_keyup_year(event, which = 0) {

      if (event.code === "ArrowLeft" || event.code === "ArrowRight") return;
      if (event.key === "Shift") return;
      if (which === 0) {
        if (event.code === "Tab" && event.shiftKey) {
          this.$refs[`datetime-input-day-${this.id}`].focus();
          this.$refs[`datetime-input-day-${this.id}`].select();
          return;
        }

        if (this.year_bind?.length > 3 || (event.code === "Tab" && !event.shiftKey)) {

          if (!this.formatDateMoment !== 'YYYY-MM-DD' && !this.noTime) {
            this.$refs[`datetime-input-hour-${this.id}`].focus();
            this.$refs[`datetime-input-hour-${this.id}`].select();
          }
        }
      } else {
        if (event.code === "Tab" && event.shiftKey) {
          this.$refs[`datetime-input-day1-${this.id}`].focus();
          this.$refs[`datetime-input-day1-${this.id}`].select();
          return;
        }
        if (this.year_bind1?.length > 3 || (event.code === "Tab" && !event.shiftKey)) {
          if (!this.formatDateMoment !== 'YYYY-MM-DD' && !this.noTime) {
            this.$refs[`datetime-input-hour1-${this.id}`].focus();
            this.$refs[`datetime-input-hour1-${this.id}`].select();
          }
        }
      }
    },
    on_keyup_hour(event, which = 0) {

      // let insert = which === 1 ? which.toString : '';
      if (event.code === "ArrowLeft" || event.code === "ArrowRight") return;
      if (event.key === "Shift") return;
      if (which === 0) {
        if (event.code === "Tab" && event.shiftKey) {
          this.$refs[`datetime-input-year-${this.id}`].focus();
          this.$refs[`datetime-input-year-${this.id}`].select();
          return;
        }

        if (this.hour_bind?.length > 1 || (event.code === "Tab" && !event.shiftKey)) {
          this.$refs[`datetime-input-min-${this.id}`].focus();
          this.$refs[`datetime-input-min-${this.id}`].select();
        }
      } else {
        if (event.code === "Tab" && event.shiftKey) {
          this.$refs[`datetime-input-year1-${this.id}`].focus();
          this.$refs[`datetime-input-year1-${this.id}`].select();
          return;
        }
        if (this.hour_bind1?.length > 1 || (event.code === "Tab" && !event.shiftKey)) {
          this.$refs[`datetime-input-min1-${this.id}`].focus();
          this.$refs[`datetime-input-min1-${this.id}`].select();
        }
      }
    },
    on_keyup_min(event, which = 0) {

      // let insert = which === 1 ? which.toString : '';
      if (event.code === "ArrowLeft" || event.code === "ArrowRight") return;
      if (event.key === "Shift") return;
      if (which === 0) {
        if (event.code === "Tab" && event.shiftKey) {
          this.$refs[`datetime-input-hour-${this.id}`].focus();
          this.$refs[`datetime-input-hour-${this.id}`].select();
          return;
        }
        if (this.min_bind?.length > 1 || (event.code === "Tab" && !event.shiftKey)) {
          this.$refs[`datetime-input-ampm-${this.id}`].focus();
          this.$refs[`datetime-input-ampm-${this.id}`].select();
        }
      } else {
        if (event.code === "Tab" && event.shiftKey) {
          this.$refs[`datetime-input-hour1-${this.id}`].focus();
          this.$refs[`datetime-input-hour1-${this.id}`].select();
          return;
        }
        if (this.min_bind1?.length > 1 || (event.code === "Tab" && !event.shiftKey)) {
          this.$refs[`datetime-input-ampm1-${this.id}`].focus();
          this.$refs[`datetime-input-ampm1-${this.id}`].select();
        }
      }
    },
    on_keyup_ampm(event, which = 0) {
      // let insert = which === 1 ? which.toString : '';
      if (event.code === "ArrowLeft" || event.code === "ArrowRight") return;
      if (event.key === "Shift") return;
      if (which === 0) {
        if (event.code === "Tab" && event.shiftKey) {
          this.$refs[`datetime-input-min-${this.id}`].focus();
          this.$refs[`datetime-input-min-${this.id}`].select();
        }
      } else {
        if (event.code === "Tab" && event.shiftKey) {
          this.$refs[`datetime-input-min1-${this.id}`].focus();
          this.$refs[`datetime-input-min1-${this.id}`].select();
        }
      }
    },
    on_keyup_enter_day(event, which = 0) {
      if (which === 0) {
        //validate is number
        if (!/^\d+$/.test(this.day_bind)) {
          this.day_bind = 1;
          return;
        }
        if (parseInt(this.day_bind) > 31) {
          this.day_bind = 31;
        }
        if (parseInt(this.day_bind) < 1) {
          this.day_bind = 1;
        }
      } else {
        //validate is number
        if (!/^\d+$/.test(this.day_bind1)) {
          this.day_bind1 = 1;
          return;
        }
        if (parseInt(this.day_bind1) > 31) {
          this.day_bind1 = 31;
        }
        if (parseInt(this.day_bind1) < 1) {
          this.day_bind1 = 1;
        }
      }
      this.setTimeFromSeparate(which);
    },
    on_keyup_enter_month(event, which = 0) {
      //validate is number
      if (which === 0) {
        if (!/^\d+$/.test(this.month_bind)) {
          this.month_bind = 1
          return;
        }

        if (parseInt(this.month_bind) > 12) {
          this.month_bind = 12
        }
        if (parseInt(this.month_bind) < 1) {
          this.month_bind = 1
        }
      } else {
        if (!/^\d+$/.test(this.month_bind1)) {
          this.month_bind1 = 1;
          return;
        }

        if (parseInt(this.month_bind1) > 12) {
          this.month_bind1 = 12;
        }
        if (parseInt(this.month_bind1) < 1) {
          this.month_bind1 = 1;
        }
      }
      this.setTimeFromSeparate(which);
    },
    on_keyup_enter_year(event, which = 0) {
      //validate is number
      if (which === 0) {
        if (!/^\d+$/.test(this.year_bind)) {
          this.year_bind = 1900;
          return;
        }

        if (parseInt(this.year_bind) > 9999) {
          this.year_bind = 9999;
        }
        if (parseInt(this.year_bind) < 1900) {
          this.year_bind = 1900;
        }
      } else {
        if (!/^\d+$/.test(this.year_bind1)) {
          this.year_bind1 = 1900;
          return;
        }

        if (parseInt(this.year_bind1) > 9999) {
          this.year_bind1 = 9999;
        }
        if (parseInt(this.year_bind1) < 1900) {
          this.year_bind1 = 1900;
        }
      }
      this.setTimeFromSeparate(which);
    },

    on_keyup_enter_hour(event, which = 0) {
      //validate is number
      if (which === 0) {
        if (!/^\d+$/.test(this.hour_bind)) {
          this.hour_bind = 1;
          return;
        }

        if (parseInt(this.hour_bind) > 12) {
          this.hour_bind = 12;
        }
        if (parseInt(this.hour_bind) < 1) {
          this.hour_bind = 1;
        }
      } else {
        if (!/^\d+$/.test(this.hour_bind1)) {
          this.hour_bind1 = 1;
          return;
        }

        if (parseInt(this.hour_bind1) > 12) {
          this.hour_bind1 = 12;
        }
        if (parseInt(this.hour_bind1) < 1) {
          this.hour_bind1 = 1;
        }
      }
      this.setTimeFromSeparate(which);
    },
    on_keyup_enter_min(event, which = 0) {
      //validate is number
      if (which === 0) {
        if (!/^\d+$/.test(this.min_bind)) {
          this.min_bind = 1;
          return;
        }

        if (parseInt(this.min_bind) > 59) {
          this.min_bind = 59;
        }
        if (parseInt(this.min_bind) < 1) {
          this.min_bind = 1
        }
      } else {
        if (!/^\d+$/.test(this.min_bind1)) {
          this.min_bind1 = 1;
          return;
        }

        if (parseInt(this.min_bind1) > 59) {
          this.min_bind1 = 59;
        }
        if (parseInt(this.min_bind1) < 1) {
          this.min_bind1 = 1
        }
      }
      this.setTimeFromSeparate(which, "on_keyup_enter_min");
    },
    on_keyup_enter_ampm(event, which = 0) {
      if (which === 0) {
        if (this.ampm_bind === "A.M." || this.ampm_bind === "A.M") this.ampm_bind = "AM";
        if (this.ampm_bind === "P.M." || this.ampm_bind === "P.M") this.ampm_bind = "PM";
        if (this.ampm_bind === "AM" || this.ampm_bind === "PM") {
          return;
        }

        switch (this.ampm_bind) {
          case 1:
          case "a":
          case "am":
          case "A":
            this.ampm_bind = "AM";
            break;
          case 2:
          case "p":
          case "pm":
          case "P":
            this.ampm_bind = "PM";
            break;
          default:
            this.ampm_bind = "AM";
        }
      } else {
        if (this.ampm_bind1 === "A.M." || this.ampm_bind1 === "A.M") this.ampm_bind1 = "AM";
        if (this.ampm_bind1 === "P.M." || this.ampm_bind1 === "P.M") this.ampm_bind1 = "PM";
        if (this.ampm_bind1 === "AM" || this.ampm_bind1 === "PM") {
          return;
        }

        switch (this.ampm_bind1) {
          case 1:
          case "a":
          case "am":
          case "A":
            this.ampm_bind1 = "AM";
            break;
          case 2:
          case "p":
          case "pm":
          case "P":
            this.ampm_bind1 = "PM";
            break;
          default:
            this.ampm_bind1 = "AM";
        }
      }
      this.setTimeFromSeparate(which);
    },
    getType() {
      return this.formatDateMoment === 'YYYY-MM-DD' || this.noTime ? 'date' : 'datetime-local';
    },
    inputchanged() {
      this.$emit("onChange");
    },
    setValue() {
      this.input = this.relativeTime;
      this.$emit('onChange', this);
    },
    isActiveRangeDate(day, type, isBadRange = false) {
      let month = day.month ? day.month == 'last' ? this.monthIndex : this.monthIndex + 2 : this.monthIndex + 1;
      let year  = this.year;
      if (month === 0) {
        year  = year - 1;
        month = 12;
      } else if (month === 13) {
        year  = year + 1;
        month = 1;
      }
      let date             = `${year}/${month}/${day.day}`;
      let input            = this.input ? moment(this.input).format('YYYY/MM/DD') : null;
      let input1           = this.input1 ? moment(this.input1).format('YYYY/MM/DD') : null;
      let rangeEndDateOver = this.rangeEndDateOver ? moment(this.rangeEndDateOver).format('YYYY/MM/DD') : null;

      let isBetween = false;
      if (type === 'between' && !isBadRange) {
        isBetween = input && input1 || rangeEndDateOver ? moment(date).isBetween(input || rangeEndDateOver, input1 || rangeEndDateOver) : false;
      } else if (type === 'between' && isBadRange) {
        isBetween = input && input1 || rangeEndDateOver ? moment(date).isBetween(input1 || rangeEndDateOver, input || rangeEndDateOver) : false;
      }
      return type === 'start' ? moment(date).isSame(input || rangeEndDateOver) : type === 'end' ? moment(date).isSame(input1 || rangeEndDateOver) : type === 'between' ? isBetween : false;
    },
    isEnableDate(day) {
      if (this.minDate !== null || this.maxDate !== null) {
        let month = day.month ? day.month == 'last' ? this.monthIndex : this.monthIndex + 2 : this.monthIndex + 1;
        let year  = this.year;
        if (month === 0) {
          year  = year - 1;
          month = 12;
        } else if (month === 13) {
          year  = year + 1;
          month = 1;
        }
        let date = `${year}/${month}/${day.day}`;
        if (this.minDate !== null && this.maxDate !== null) {
          return moment(date).isBetween(this.minDate, this.maxDate);
        } else if (this.minDate !== null) {
          return moment(date).isSameOrAfter(this.minDate);
        } else if (this.maxDate) {
          return moment(date).isBefore(this.maxDate);
        }
      } else {
        return true;
      }
    },
    clearTime() {
      this.setHour(11);
      this.setMinute(0);
      this.period = AM;
      //this.$emit('clearTime');
      // } else {
      if (this.enableClearTime) {
        this.$emit('clearTime');
      }
    },
    checkDaysRemaining(days_remaining) {
      let return_val = false;
      /*let array = days_remaining.split(" ");
      if (days_remaining == 'In Progress' || array[array.length - 1] == 'ago') {
        return_val = true;
      }*/
      return return_val;
    },
    validate_input() {
      if (this.required) {
        if (!this.input || `${this.input}`.length == 0 || this.input.length == 0) {
          this.isValid = false;
          this.validText = null;
          this.invalidText = ['This Field is Required'];
          return false//{isValid: false, errors: ['This Field is Required']}
        } else {
          this.isValid = true;
          this.validText = null;
          this.invalidText = null;
          return true;
        }
      }
      if (this.validation) {
        let res          = this.validation(this.input, this.dataSource);
        this.isValid     = res.isValid;
        this.validText   = res.correct ? res.correct : null;
        this.invalidText = res.errors ? res.errors : null;
        return res.isValid;
      } else {
        return true;
      }
    },
    on_keyup_enter(event, close_cal = true) {

      if (this.inputType === 'list') {
        this.$parent.data_provider_ref[this.inputType][this.index][this.dataSource] = event.target.value;
      } else {
        this.$parent.data_provider_ref[this.inputType][this.dataSource] = event.target.value;
      }
      this.$emit('onChange', this);
      if (close_cal) this.closeCal();
    },

    leftMonth() {
      let index = this.months.indexOf(this.month)
      if (index === 0) {
        this.monthIndex = 11
        this.leftYear()
      } else {
        this.monthIndex = index - 1
      }
      this.updateCalendar()
    },
    rightMonth() {
      let index = this.months.indexOf(this.month)
      if (index === 11) {
        this.monthIndex = 0
        this.rightYear();
      } else {
        this.monthIndex = index + 1
      }
      this.updateCalendar()
    },
    rightYear() {
      this.year++
      this.updateCalendar()
    },
    leftYear() {
      this.year--
      this.updateCalendar()
    },
    updateActivePortFromWeek(week, weekIndex) {
      const currentActive = startOfDay(this.timeStamp);

      this.today  = new Date().getDate();
      const index = week.findIndex(day => isEqual(currentActive, day));

      if (index !== -1) {
        this.activePort = weekIndex * 7 + index;
      }
    },
    updateCalendar() {
      const date      = new Date(this.year, this.monthIndex, 1, 0, 0, 0);
      const datelast  = new Date(this.year, this.monthIndex - 1, 1, 0, 0, 0);
      const datenext  = new Date(this.year, this.monthIndex + 1, 1, 0, 0, 0);
      const weeks     = [];
      let week        = null;
      let weekDays    = new Array(7);
      // let index = 0;
      this.activePort = null;
      eachDay({start: date, end: endOfMonth(date)}).forEach(day => {
        const weekday = getDay(day);
        if (weekday === this.normalizedFirstDayOfWeek) {
          if (week) {
            weeks.push(week);
            // Add those days that were not part of the month to the index
            // index += week.filter(d => d === null).length;
            this.updateActivePortFromWeek(weekDays, weeks.length - 1);
            weekDays = new Array(7);
          }
          week = new Array(7);
        } else if (week === null) {
          week = new Array(7);
        }
        const idx     = (weekday - this.normalizedFirstDayOfWeek + 7) % 7
        week[idx]     = {'day': format(day, 'dd')};
        weekDays[idx] = day;
      });
      if (week && week.some(n => n)) {
        weeks.push(week);
        this.updateActivePortFromWeek(weekDays, weeks.length - 1);
      }
      weeks.forEach(daweek => {
        let index = daweek.findIndex(day => day);
        if (index > 0) {
          let value = endOfMonth(datelast);
          var d     = new Date(value);
          var n     = d.getDate();
          for (let i = index - 1; i > -1; i--) {
            daweek[i] = {'day': n, 'month': 'last'};
            n--;
          }
        }

        index = daweek.findIndex(day => !day);
        if (index > -1) {
          let value = startOfMonth(datenext);
          var d     = new Date(value);
          var n     = d.getDate();
          for (let i = index; i < 7; i++) {
            daweek[i] = {'day': n, 'month': 'next'};
            n++;
          }
        }
      });

      this.weeks = weeks;
    },
    setDay(index, port, over = false) {
      if (port) {
        if (!this.isRangeEndDate && !over) this.activePort = index;
        this.day  = parseInt(port.day, 10);
        let month = this.monthIndex;
        if (port.month) {
          if (port.month == 'last') {
            month--;
          }
          if (port.month == 'next') {
            month++
          }
        }
        this.timeStamp = new Date(this.year, month, this.day.day);
      }
      this.setDate(port.month, !this.onlyUpdateOnSubmit, over);
    },
    isToday(day) {
      var d = new Date();
      return !day.month ? day.day == d.getDate() && this.isCurrentMonth : false;
      /*return td.getDate() == d.getDate() && td.getMonth() == d.getMonth() && td.getFullYear() == d.getFullYear();*/
    },
    setMinute(index, closeAfterSet) {
      this.minuteIndex = index
      this.minute      = this.minutes[index]
      if (closeAfterSet) {
        this.minuteSelectorVisible = false
      }
      this.setDate(null, false);
      if (!this.onlyUpdateOnSubmit) this.$emit('onChange', this);
    },
    setHour(index, closeAfterSet) {
      this.hourIndex = index
      this.hour      = this.hours[index]
      if (closeAfterSet) {
        this.hourSelectorVisible = false
      }
      this.setDate(null, false);
      if (!this.onlyUpdateOnSubmit) this.$emit('onChange', this);
    },
    showHourSelector() {
      this.hourSelectorVisible   = true
      this.minuteSelectorVisible = false
    },
    showMinuteSelector() {
      this.minuteSelectorVisible = true
      this.hourSelectorVisible   = false
    },
    keyIsDown(event) {
      let key = event.which || event.keycode
      if (key === 38) {
        if (this.minuteSelectorVisible && this.minuteIndex > 0) {
          this.setMinute(this.minuteIndex - 1, false)
          this.scrollTopMinute()
        } else if (this.hourSelectorVisible && this.hourIndex > 0) {
          this.setHour(this.hourIndex - 1, false)
          this.scrollTopHour()
        }
      } else if (key === 40) {
        if (this.minuteSelectorVisible && this.minuteIndex < this.minutes.length - 1) {
          this.setMinute(this.minuteIndex + 1, false)
          this.scrollTopMinute()
        } else if (this.hourSelectorVisible && this.hourIndex < this.hours.length - 1) {
          this.setHour(this.hourIndex + 1, false)
          this.scrollTopHour()
        }
      } else if (key === 13) {
        this.minuteSelectorVisible = false
        this.hourSelectorVisible   = false
      }
      if (this.minuteSelectorVisible || this.hourSelectorVisible) {
        event.preventDefault()
        this.minuteSelectorVisible = false
        this.hourSelectorVisible   = false
      }
    },
    scrollTopMinute() {
      let mHeight                         = this.$refs.minuteScroller.scrollHeight
      let wHeight                         = this.$refs.minuteScrollerWrapper.clientHeight
      let top                             = mHeight * (this.minuteIndex / (this.minutes.length - 1)) - (wHeight / 2)
      this.$refs.minuteScroller.scrollTop = top
    },
    scrollTopHour() {
      let mHeight                       = this.$refs.hourScroller.scrollHeight
      let wHeight                       = this.$refs.hourScrollerWrapper.clientHeight
      let top                           = mHeight * (this.hourIndex / (this.hours.length - 1)) - (wHeight / 2)
      this.$refs.hourScroller.scrollTop = top
    },
    changePeriod() {
      this.period = this.period === AM ? PM : AM;
      this.setDate(null, false);
    },
    calendarClicked(event) {
      if (event.target.id !== 'j-hour' && event.target.id !== 'j-minute') {
        this.minuteSelectorVisible = false
        this.hourSelectorVisible   = false
      }
      event.cancelBubble = true
      if (event.stopPropagation) {
        event.stopPropagation()
      }
    },
    documentClicked(event) {
      if (event.target.id !== 'datetime-input') {
        if (this.dateRange && !this.input && this.input1) {
          this.hideCal = false;
          document.getElementById(`datetime-input${this.id}`).focus();
        } else {
          this.hideCal = true;
        }
        /*this.show_as = "days_remaining";*/
      }
    },
    /*toggleCal() {
        this.hideCal = !this.hideCal
    },*/
    openCal(type = 0, location = 0) {
      if (this.hideCal) this.$emit('open', this.id, this.$parent.data_provider_ref[this.inputType][this.index]);
      this.hideCal              = false;
      this.openDateTimePickerId = this._uid;
      let input                 = location ? this.input1 : this.input;
      if (input && moment(new Date(input)).isValid) {
        this.validate_input();
        try {
          this.timeStamp = this.makeDateObject(input);
        } catch (e) {
          console.warn(e.message + '. Current date is being used.');
          this.timeStamp = new Date();
        }
      } else {
        let value      = moment().startOf("day").format('YYYY-MM-DD HH:mm:ss');
        this.timeStamp = this.makeDateObject(value);
      }
      this.year       = this.timeStamp.getFullYear();
      this.monthIndex = this.timeStamp.getMonth();
      this.deadDays   = getDay(this.monthIndex) + 1;
      this.day        = this.timeStamp.getDate();
      this.hour       = this.timeStamp.getHours();
      this.hour       = this.hour < 10 ? '0' + this.hour : '' + this.hour;


      this.minute = this.timeStamp.getMinutes();
      this.minute = this.minute < 10 ? '0' + this.minute : '' + this.minute;
      this.updateCalendar();
      //this.date = newVal == null ? '' : newVal;
      //this.setAmPm();
      /*} else {
        this.date = oldVal == null ? '' : oldVal;
      }*/
      //},
      if (this.dateRange && this.dataSource1) {
        this.isRangeEndDate = type == 1 ? true : false;
      }
    },
    closeCal() {
      this.hideCal = true;
    },
    setPeriodStyle() {
      if (this.dateFormat.indexOf('H') !== -1) {
        this.periodStyle = 24;
        this.period      = null;
      } else {
        this.periodStyle = 12;
      }
    },
    setDate(diffMonth = null, close = true, over = false) {
      let d = null
      this.setPeriodStyle()
      let h = this.hour + ''
      if (this.periodStyle === 12) {
        if (h === '12') {
          h = this.period === AM ? '00' : '12'
        } else if (this.period === PM && parseInt(h) < 12) {
          h = parseInt(h) + 12
          h = '' + h
        } else if (this.period === AM && parseInt(h) > 12) {
          h = parseInt(h) - 12
          h = '' + h
        }
      }
      d = this.dateFormat
      d = d.replace('YYYY', this.year)
      d = d.replace('DD', this.day < 10 ? '0' + this.day : this.day)

      let m = diffMonth ? diffMonth == 'last' ? this.monthIndex : this.monthIndex + 2 : this.monthIndex + 1
      d     = d.replace('MM', m < 10 ? '0' + m : m)
      this.minute += ''
      d     = d.replace(this.periodStyle === 24 ? 'H' : 'h', h.length < 2 ? '0' + h : '' + h)
      d     = d.replace('i', this.minute.length < 2 ? '0' + this.minute : '' + this.minute)
      d     = d.replace('s', '00')

      /*if (close) {
        this.$emit('onChange', this);
        this.hideCal = true
      }*/

      if (!over) {
        this.$emit('input', d)
        this.date = d;
        if (!this.isRangeEndDate) {
          this.input = d;
          if (this.dateRange && this.validateDateRange) {
            if (this.input1) {
              if (moment(this.input1).isBefore(this.input)) {
                this.input1 = this.input;
              }
            }
            if (this.autoFocusRangeEndDate) {
              document.getElementById(`datetime-input-end-${this.id}`).focus();
            } else {
              if (close) {
                this.$emit('onChange', this);
                this.hideCal = true
              }
            }
          } else {
            if (close) {
              this.$emit('onChange', this);
              this.hideCal = true
            }
          }
        } else {
          this.input1 = d;
          if (this.validateDateRange) {
            if (this.input) {
              if (moment(this.input).isAfter(this.input1)) {
                this.input1 = this.input;
              }
              if (close) {
                this.$emit('onChange', this);
                this.hideCal = true
              }
            } else {
              document.getElementById(`datetime-input${this.id}`).focus();
            }
          } else {
            if (close) {
              this.$emit('onChange', this);
              this.hideCal = true
            }
          }
        }
      } else {
        this.rangeEndDateOver = d;
      }
    },
    /**
     `*Creates a date object from a given date string
     */
    makeDateObject(val) {
      // handle support for eu date format
      let dateAndTime = val.split(' ')
      let arr         = []
      if (this.formatDate.indexOf('-') !== -1) {
        arr = dateAndTime[0].split('-')
      } else {
        arr = dateAndTime[0].split('/')
      }
      let year  = 0
      let month = 0
      let day   = 0
      if (this.formatDate.indexOf('DD/MM/YYYY') === 0 || this.formatDate.indexOf('DD-MM-YYYY') === 0) {
        year  = arr[2]
        month = arr[1]
        day   = arr[0]
      } else if (this.formatDate.indexOf('YYYY/MM/DD') === 0 || this.formatDate.indexOf('YYYY-MM-DD') === 0) {
        year  = arr[0]
        month = arr[1]
        day   = arr[2]
      } else {
        year  = arr[2]
        month = arr[0]
        day   = arr[1]
      }
      let date = new Date();
      if (this.hideDate) {
        // time only
        let splitTime = dateAndTime[0].split(':')
        // handle date format without seconds
        let secs      = splitTime.length > 2 ? parseInt(splitTime[2]) : 0
        date.setHours(parseInt(splitTime[0]), parseInt(splitTime[1]), secs, 0)
      } else if (this.hideTime) {
        // date only
        date = new Date(parseInt(year), parseInt(month) - 1, parseInt(day))
      } else {
        // we have both date and time
        let splitTime = dateAndTime[1].split(':')
        // handle date format without seconds
        let secs      = splitTime.length > 2 ? parseInt(splitTime[2]) : 0
        date          = new Date(parseInt(year), parseInt(month) - 1, parseInt(day), parseInt(splitTime[0]), parseInt(splitTime[1]), secs)
      }
      return date
    },
    clearDate(init = false) {
      if (init) {
        this.input  = null;
        this.input1 = null;
      }
      this.date             = '';
      this.rangeEndDateOver = null;
      if (!this.isRangeEndDate) {
        this.input = null;
        setTimeout(() => {
          document.getElementById(`datetime-input${this.separateFields ? '-month-' : ''}${this.id}`).focus();
        }, 100);
      } else {
        this.input1 = null;
        setTimeout(() => {
          document.getElementById(`datetime-input-end-${this.id}`).focus();
        }, 100);

      }
      this.$emit('onChange', this);
    },
    setAmPm() {
      if (this.timeStamp.getHours() >= 12) {
        this.period = PM
      } else {
        this.period = AM
      }
    },
    init() {
      this.date = this.input == null ? '' : this.input;

      if (this.input1) {
        this.setInput(this.input, 1);

      }
      if (this.input) {
        this.setInput(this.input, 0);
        try {
          this.timeStamp = this.makeDateObject(this.input)
          this.setAmPm();
          // set #period (am or pm) based on date hour

        } catch (err) {
          this.timeStamp = new Date();
          this.timeStamp.setHours(0, 0, 0, 0);
          //this.clearTime();
          this.setAmPm();
        }
      } else {
        this.timeStamp.setHours(0, 0, 0, 0);
        //this.clearTime();
      }

      this.year       = this.timeStamp.getFullYear()
      this.monthIndex = this.timeStamp.getMonth()

      this.deadDays = getDay(this.monthIndex) + 1;
      this.day      = this.timeStamp.getDate()
      this.hour     = this.timeStamp.getHours()
      this.hour     = this.hour < 10 ? '0' + this.hour : '' + this.hour
      this.minute   = this.timeStamp.getMinutes()
      this.minute   = this.minute < 10 ? '0' + this.minute : '' + this.minute
      this.updateCalendar()
      days.forEach((day, idx) => {
        this.days[(idx - this.normalizedFirstDayOfWeek + 7) % 7] = day;
      });
      document.addEventListener('keydown', this.keyIsDown)
      if (!this.calendarOnly) document.addEventListener('click', this.documentClicked)
      this.setPeriodStyle();
    }
  },
  data() {
    return {
      showPlaceHolder:       false,
      timer:                 null,
      relativeTime:          null,
      id:                    null,
      isValid:               null,
      isRangeEndDate:        false,
      rangeEndDateOver:      null,
      validText:             null,
      invalidText:           null,
      date:                  this.input, //this.$parent.data_provider_ref[this.inputType][this.dataSource],
      hideCal:               !this.calendarOnly,
      activePort:            null,
      today:                 null,
      timeStamp:             new Date(),
      todayTimeStamp:        new Date(),
      months:                ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
      days:                  [],
      weeks:                 [],
      monthIndex:            0,
      hourIndex:             0,
      minuteIndex:           0,
      year:                  2017,
      portsHolder:           [],
      minute:                '00',
      hour:                  '01',
      day:                   1,
      day_bind:              null,
      month_bind:            null,
      year_bind:             null,
      hour_bind:             null,
      min_bind:              null,
      ampm_bind:             null,
      day_bind1:             null,
      month_bind1:           null,
      year_bind1:            null,
      hour_bind1:            null,
      min_bind1:             null,
      ampm_bind1:            null,
      minuteSelectorVisible: false,
      hourSelectorVisible:   false,
      period:                AM,
      periodStyle:           12,
      noDataSoureDate:       "0000-00-00 00:00:00",
      /*years: [
          1930,
      ]*/
    }
  },
  created() {
    this.init();
  },
  destroyed: function () {
    document.removeEventListener('keydown', this.keyIsDown)
    document.removeEventListener('click', this.documentClicked)
  },
}
</script>

<style scoped>

.gray {
  color: lightgray !important;
}

.year-month-wrapper {
  background-color: #007bff;
}

input {
  /*min-width: 226px;
  width:100%;
  height: 30px;
  padding: 3px;
  border: 1px solid #ddd;*/
}

.datetime-picker {
  position: relative;
}

.calender-div {
  min-width: 210px;
  box-shadow: 1px 2px 5px #ccc;
  background: #FFF;
  position: absolute;
  display: inline-block;
  left: 0;
  top: 35px;
  color: #444;
  font-size: 14px;
  padding-bottom: 10px;
  z-index: 100;
}

.port, .days {
  display: inline-block;
  width: 30px;
  height: 30px;
  padding: 5px 3px;
  text-align: center;
  vertical-align: top;
  cursor: pointer;
}

.port-disabled {
  display: inline-block;
  width: 30px;
  height: 30px;
  padding: 5px 3px;
  vertical-align: top;
  color: lightgray !important;
  cursor: default !important;
}

.days {
  color: #007bff;
  font-weight: bold;
}

.port:hover {
  color: #007bff;
  font-weight: bold;
}

.errorRangePort .gray {
  color: red !important;
}

.activeRangePort .gray {
  color: #494949 !important;
}

.activeRangePort {
  background-color: #c2c5c7;
}

.errorRangePort {
  background-color: #c2c5c7;
  color: red;
}

.activePort, .activePort:hover {
  background-color: #007bff;
  color: white;
}

.today, .today:hover {
  border: 1px dashed red;
}

.month-setter, .year-setter {
  margin: 0 1px;
  width: 48.2%;
  color: white;
  font-weight: 900;
  display: inline-block;
}

.nav-l:hover, .nav-r:hover {
  background-color: #007bff;
}

.nav-l, .nav-r {
  display: inline-block;
  width: 25px;
  background-color: #007bff;
  color: white;
  font-size: 16px;
  cursor: pointer;
  border: 0;
  padding: 7px;
  margin: 0;
}

.nav-l:focus, .nav-r:focus {
  outline: none;
}

.nav-l {
  /*float: left;*/
}

.nav-r {
  /*float: right;*/
}

.month, .year {
  /*width: 40px;*/
  text-align: center;
  /*display: inline-block;*/
  color: white;
  padding: 7px 0;
}

/* .headers>span{

} */
.hour-selector, .minute-selector {
  display: inline;
  text-align: center;
  font-weight: bold;
  position: relative;
  cursor: pointer;
}

.selector-width-on {
  width: 210px;
}

.selector-width-on-minute {
  width: 210px;
}

.selector-width-on-hour {
  width: 135px;
}

.time-separator {
  display: inline-block;
  font-weight: bold;
}

.time-picker {
  margin: 10px
}

.nav-t, .nav-d {
  font-weight: bold;
  cursor: pointer;
}

.scroll-hider {
  display: none;
  vertical-align: top;
  overflow: auto;
  border: 0;
  box-shadow: 0 0 3px #333;
  background-color: white;
  max-height: 70vh;
  z-index: 1;
}

.scroll-hider div {
  padding: 5px;
  list-style-type: none;
  overflow: auto;
  color: #999;
  overflow-x: hidden;
}


.showSelector {
  display: inline-block;
}

li.active {
  background-color: #007bff;
  color: white;
}

li {
  padding: 4px;
  font-size: 16px;
  width: 100%;
  cursor: pointer;
}

.noDisplay {
  display: none;
}

.okButton {
  color: #007bff;
  font-size: 15px;
  font-weight: bold;
  padding: 0;
  border: 0;
  margin: 10px;
  cursor: pointer;
  background: transparent;
}

.hovered {
  color: #2779F6 !important;
  cursor: pointer;
}

#datetime-input:hover {
  text-decoration: underline !important;
}

.red {
  color: red !important;
}

a {
  color: black !important;
}

.rangeLabelContainer {
  display: flex;
}

.rangeLabel {
  flex: 1;
  display: inline-block;
  margin-bottom: .4rem;
}

input[type="date"]::-webkit-inner-spin-button,
input[type="date"]::-webkit-calendar-picker-indicator {
  display: none;
  -webkit-appearance: none;
}

input[type="datetime-local"]::-webkit-inner-spin-button,
input[type="datetime-local"]::-webkit-calendar-picker-indicator {
  display: none;
  -webkit-appearance: none;
}

.separate-dt {
  padding: 0;
  margin: 0;
  border: 0;
  font-size: small;
}

.inline-input {
  margin: 0 -13px;
}

.slash {
  color: #b1b1b1;

}

.is-invalid {
  border: 1px solid #dc3545;
  padding-right: calc(1.5em + .75rem)!important;
  background-image: url("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2712%27 height=%2712%27 fill=%27none%27 stroke=%27%23dc3545%27 viewBox=%270 0 12 12%27%3e%3ccircle cx=%276%27 cy=%276%27 r=%274.5%27/%3e%3cpath stroke-linejoin=%27round%27 d=%27M5.8 3.6h.4L6 6.5z%27/%3e%3ccircle cx=%276%27 cy=%278.2%27 r=%27.6%27 fill=%27%23dc3545%27 stroke=%27none%27/%3e%3c/svg%3e");
  background-repeat: no-repeat;
  background-position: right calc(.375em + .1875rem) center;
  background-size: calc(.75em + .375rem) calc(.75em + .375rem);
}

/*input::placeholder {
  color: #f4f4f4;
}
input:focus::placeholder {
  color: #bfbdbd
}*/
</style>
